import { useState, useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { addAddress, updateAddress, deleteAddress, AddressType } from '../../../../../../services/RegistrationService/registrationSlice/';

/**
 * Hook for managing address grid actions
 */
export function useAddressActions(addresses: AddressType[]) {
  const dispatch = useAppDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState<AddressType | null>(null);

  const handleAddAddress = useCallback(() => {
    setEditingAddress(null);
    setDialogOpen(true);
  }, []);

  const handleEditAddress = useCallback((address: AddressType) => {
    setEditingAddress(address);
    setDialogOpen(true);
  }, []);

  const handleDeleteAddress = useCallback(
    (addressType: string) => {
      if (window.confirm('Are you sure you want to delete this address?')) {
        const index = addresses.findIndex((addr) => addr.addressType === addressType);
        if (index >= 0) {
          dispatch(deleteAddress(index));
        }
      }
    },
    [addresses, dispatch]
  );

  const handleSaveAddress = useCallback(
    (addressData: AddressType) => {
      const existingIndex = addresses.findIndex(
        (addr) => addr.addressType === addressData.addressType
      );
      if (existingIndex >= 0) {
        // Updating existing address
        dispatch(updateAddress({ index: existingIndex, address: addressData }));
      } else {
        // Adding new address
        dispatch(addAddress(addressData));
      }
    },
    [addresses, dispatch]
  );

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false);
    setEditingAddress(null);
  }, []);

  return {
    dialogOpen,
    editingAddress,
    handleAddAddress,
    handleEditAddress,
    handleDeleteAddress,
    handleSaveAddress,
    handleDialogClose,
  };
}
